import gql from 'graphql-tag'

import AutomationHandler from './AutomationHandler'
import list from './gql/listAutomationTasks'
import updateServerTask from './gql/updateAutomationTaskServer'
import createServerTask from './gql/createAutomationTaskServer'
import deleteServerTask from './gql/deleteAutomationTaskServer.js'
import { listCols } from './tableColumns'
import { AutomationTask } from './pages'

const conf = t => ({
	link: 'automation',
	baseUrl: '',
	typename: 'AutomationTaskServer',
	subsections: [{
		link: '',
		component: AutomationTask,
		updateMutation: updateServerTask,
		subsectionQuery: gql`query{_}`
	}],
	addNewRecord: true,
	listQuery: list,
	createMutation: createServerTask,
	deleteMutation: deleteServerTask,
	columns: listCols(t),
	handler: AutomationHandler
})

export default conf
